const enum UserRole {
  Staff = "Staff",
  Student = "Student",
  Investor = "Investor",
}

export default UserRole;
